import { LassoSelectionStates } from "types/lasso";

import { getLineChartFilteredItems } from "./utils";

export function getCagrList({ params, series }: Partial<LassoSelectionStates>) {
  const list = getLineChartFilteredItems(params, series, true);
  return list;
}
